import { Configurations } from "./Interfaces/Configurations";

const config: Configurations = {
  development: {
    apiUrl: 'https://localhost:32775/api',
    websiteUrl: 'http://localhost:3000',
    tenant: 6,
    bucketStripe: "prod_U4QISbVCL4OYyU",
    deliveryStripe: "prod_U6YB1TsPQvYE4W",
    YardStripe: "prod_U6YBRCngWBdBSY"

  },
  production: {
    apiUrl: 'https://api.yourtools.us/api',
    websiteUrl: 'https://1earthcomposting.com',
    tenant: 6,
    bucketStripe: "prod_OJjPfWt4f0ygga",
    deliveryStripe: "prod_Pztw9VvWevBgqv",
    YardStripe: "prod_PztpPWEOvcFns4"

  }
};

const environment = (process.env.NODE_ENV || 'development') as keyof Configurations;
export default config[environment];